module.exports = __webpack_public_path__ + "static/media/mood-happy.a8e2536f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mood-happy.svg
// module id = 530
// module chunks = 31